import { useEffect, useState, useContext, createContext } from "react";

const medalsContext = createContext();

export function ProvideMedals({ children }) {
  const medals = useProvideMedals();
  return (
    <medalsContext.Provider value={medals}>{children}</medalsContext.Provider>
  );
}

export const useMedals = () => {
  return useContext(medalsContext);
};

const useProvideMedals = () => {
  const [medals, setMedals] = useState([]);

  useEffect(() => {
    const fetchMedalsData = async () => {
      try {
        const response = await fetch(
          "https://graphics.thecanadianpress.com/paris2024/MedalsData/data.json",
          {
            headers: {
              'Pragma': 'no-cache',
              'Cache-Control': 'no-cache'
            }
          }
        );
        if (response.ok) {
          const data = await response.json();
          setMedals(data);
        } else {
          throw new Error("Network response was not ok");
        }
      } catch (err) {
        setMedals([]); // Fallback to an empty array if the fetch fails
      }
    };

    fetchMedalsData(); // Call immediately on component mount

    const intervalId = setInterval(fetchMedalsData, 60000);

    return () => clearInterval(intervalId); // Clear the interval when the component unmounts
  }, []);

  return { medals };
};